
const seccionesRef = {
    categorias: 'seccionCategorias',
    populares: 'seccionPopulares',
    recientes: 'seccionRecientes',
    favoritos: 'seccionFavoritos'
};

const config =  {
    entregaInmediata : 'TIEN1',
    entregaProgramada: 'TIEN2',
    domicilio: 'LUEN2',
    pickup: 'LUEN1',
    paypal: 'MP8',
    pagoTC: 'MP4',
    PagoEfectivo: 'MP1',
    cargoEntrega: 'DELIVERY',
    origen: 'ORG3',
    recargoMontoMinimo: 'VA1',
    montoMinimoPedido: 'VA2',
    recargoFueraCascoUrbano: 'VA3',
    pickupIdCategory: -1,
    idPreparacionTradicional: 2,
    idPreparacionVegano: 1,
    cobrarRecargoMontoMinimo: 'VA8',
    cobrarRecargoFueraCascoUrbano: 'VA9'
};

const dbLocalIndex = {
    presentacion: 'presentacion',
    infoUser: 'user',
    goProductDetail: 'goProductDetail',
    carrito: 'carrito',
    colonias: 'colonias',
    tipoDireccion: 'tipodireccion',
    direccionEntrega: 'direccionEntrega',
    direcciones: 'direcciones',
    lugarEntrega: 'lugarentrega',
    tipoEntrega: 'tipoentrega',
    tipoEntregaSeleccionada: 'tipoEntregaSeleccionada',
    lugarEntregaSeleccionado : 'lugarEntregaSeleccionado',
    fechaEntrega : 'fechaEntregaSeleccionada',
    preferenciasPedido: 'preferenciasPedido',
    preferenciaPedidoOtros: 'preferenciaPedidoOtros',
    metodoPagoSeleccionado: 'metodoPagoSeleccionado',
    infoTC: 'infoTarejta',
    infoPago: 'infoPago',
    categorias: 'categorias',
    busquedaProductos: 'busquedaProductos',
    direccionBreabLab: 'direccionBreabLab',
    rtn: 'RTN',
    otp: 'OTP',
    userTemp: 'userTemp',
    userCheck: 'userCheck',
    condicionesPago: 'condicionesPago',
    disponibilidadInmediata: 'disponibilidadInmediata',
    categoriaSeleccionadaMenu: 'categoriaSeleccionadaMenu',
    USER_KEY: 'auth-user',
    PLATFORM: 'platform',
    anuncioCargado: 'anuncioCargado',
    haveCoupon: 'haveCoupon',
    couponInfo: 'couponInfo'
};

const pages = {
    onboarding: 'onboarding',
    login: 'login',
    forgotpassword: 'forgotpassword',
    signup: 'signup',
    otp: 'otp',
    home: 'home',
    homeitem: 'home/:id',
    products: 'products',
    productdetail: 'productdetail',
    wishlist: 'wishlist',
    search: 'search',
    cart: 'cart',
    address: 'address',
    payment: 'payment',
    summary: 'summary',
    successmodal: 'successmodal',
    notifications: 'notifications',
    myorders: 'myorders',
    orderdetails: 'orderdetails',
    addreview: 'addreview',
    settings: 'settings',
    profile: 'profile',
    signout: 'signout',
    useraddress: 'useraddress',
    preferencias: 'preferencias',
    typedelivery: 'typedelivery',
    ordendetailsproducts: 'ordendetailsproducts',
    editprofile: 'editprofile',
    errors: 'errors'
};

const titlePages = {
    default: 'Bread Lab',
    onboarding: 'onboarding',
    login: 'login',
    forgotpassword: 'forgotpassword',
    signup: 'signup',
    otp: 'otp',
    home: 'home',
    products: 'products',
    productdetail: 'productdetail',
    wishlist: 'wishlist',
    search: 'search',
    cart: 'cart',
    address: 'address',
    payment: 'payment',
    summary: 'summary',
    successmodal: 'successmodal',
    notifications: 'notifications',
    myorders: 'myorders',
    orderdetails: 'orderdetails',
    addreview: 'addreview',
    settings: 'settings',
    profile: 'profile',
    signout: 'signout',
    useraddress: 'useraddress',
    preferencias: 'preferencias',
    typedelivery: 'typedelivery',
    ordendetailsproducts: 'ordendetailsproducts',
    editprofile: 'editprofile',
    errors: 'errors'
};


const currency = {
    hnl: 'HNL',
    usd: 'USD'
};

const tipoTarjetas = {
    visa : 'visa',
    masterCard : 'mastercard',
    americanExpress: 'americanexpress'
};

const regex = {
    tarjetasCredito : {
        cvv: /^[0-9]{3}$/,
        cvvAmericanExpress: /^[0-9]{3,4}$/,
        visa :  /^4[0-9]{12}(?:[0-9]{3})?$/,
        masterCard : /^(?:5[1-5][0-9]{2}|222[1-9]|22[3-9][0-9]|2[3-6][0-9]{2}|27[01][0-9]|2720)[0-9]{12}$/,
        americanExpress : /^3[47][0-9]{13}$/,
        all : /^(?:(4[0-9]{12}(?:[0-9]{3})?)|(5[1-5][0-9]{14})|(6(?:011|5[0-9]{2})[0-9]{12})|(3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|((?:2131|1800|35[0-9]{3})[0-9]{11}))$/
    },
    correo:  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    telefono: /^([9,8,3][0-9]{3})+(-)[0-9]{4}$/,
    telefonoFijo: /^([2][0-9]{3})+(-)[0-9]{4}$/,
    fechas: /^(?:(?:31(\/|-|\.)(?:0?[13578]|1[02]))\1|(?:(?:29|30)(\/|-|\.)(?:0?[13-9]|1[0-2])\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:29(\/|-|\.)0?2\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:0?[1-9]|1\d|2[0-8])(\/|-|\.)(?:(?:0?[1-9])|(?:1[0-2]))\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/
};

const labels = {
    loading: 'Cargando...',
    waiting: 'Espere un momento...',
    processingPayment: 'Procesando Pago...',
    saveOrder : 'Generando Pedido...'
};

export { seccionesRef, config, dbLocalIndex, pages, currency, tipoTarjetas, regex, labels, titlePages };
